import { useCallback } from 'react';
import { useWidgetDispatch } from '../contexts';

export function useSubmitMessage() {
  const dispatch = useWidgetDispatch();

  return useCallback(() => {
    return dispatch({
      type: 'toggleSubmitted',
      submitted: true
    });
  }, [dispatch]);
}
